import { render, staticRenderFns } from "./StockVideoBox.vue?vue&type=template&id=788b28b6&scoped=true"
import script from "./StockVideoBox.vue?vue&type=script&lang=js"
export * from "./StockVideoBox.vue?vue&type=script&lang=js"
import style0 from "./StockVideoBox.vue?vue&type=style&index=0&id=788b28b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b28b6",
  null
  
)

export default component.exports